// initial state
const state = {
    menuOpened: false,
    heartbeat: false,
    invertTheme: false,
    isDesktop: false,
    isMobile: false,
    isTouch: false,
    canAutoplay: false,
    seo: {},
}

// getters
const getters = {
    isMobile: (state) => state.isMobile,
    isDesktop: (state) => state.isDesktop,
    isTouch: (state) => state.isTouch,
    canAutoplay: (state) => state.canAutoplay,
    isInvertTheme: (state) => state.invertTheme,
    seo: (state) => state.seo,
}

// actions
const actions = {
    toggleHeartbeat({commit}) {
        commit('setHeartbeat', true)
        setTimeout(() => {
            commit('setHeartbeat', false)
        }, 1300 / 2)
    },
    closeMenu({commit}) {
        commit('closeMenu')
    },
    invertTheme({commit}, value) {
        commit('invertTheme', value)
    },
    setSeo({commit}, value) {
        commit('setSeo', value)
    }
}

// mutations
const mutations = {
    openMenu(state) {
        state.menuOpened = true
    },
    closeMenu(state) {
        state.menuOpened = false
    },
    toggleMenu(state) {
        state.menuOpened = !state.menuOpened
    },
    setHeartbeat(state, value) {
        state.heartbeat = value
    },
    invertTheme(state, value) {
        state.invertTheme = value
    },
    isMobile(state, value) {
        state.isMobile = value
        state.isDesktop = !value
    },
    isTouch(state, value) {
        state.isTouch = value
    },
    canAutoplay(state, value) {
        state.canAutoplay = value
    },
    setSeo(state, value) {
        state.seo = value || {}
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
